import React from "react";
import {
    Box,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Table
} from '@material-ui/core';

export default class ComponentToPrint extends React.Component {
    render() {
        const searchValues = this.props.selectedSearchValues;
        const tableData = this.props.tableData;

        return (
            <div>
                <h2><center><u>Employee Biometric Report</u></center></h2>
                <h3><center>Group : {searchValues.groupName}</center></h3>
                <h3><center>Factory : {searchValues.factoryName}</center></h3>
                <h4><center>{'Employee Type: ' + searchValues.employeeTypeName}</center></h4>

                <div>&nbsp;</div>
                <Box minWidth={1050} display="flex" justifyContent="flex-end" p={2}>
                    <TableContainer>
                        <Table aria-label="caption table" >
                            <TableHead>
                                <TableRow style={{ border: '1px solid black' }}>
                                    <TableCell align="center" style={{ fontWeight: "bold", border: "1px solid black" }}>Reg No</TableCell>
                                    <TableCell align="center" style={{ fontWeight: "bold", border: "1px solid black" }}>Employee Code</TableCell>
                                    <TableCell align="center" style={{ fontWeight: "bold", border: "1px solid black" }}>Employee Name</TableCell>
                                    <TableCell align="center" style={{ fontWeight: "bold", border: "1px solid black" }}>Employee NIC</TableCell>
                                    <TableCell align="center" style={{ fontWeight: "bold", border: "1px solid black" }}>Employee Type</TableCell>
                                    <TableCell align="center" style={{ fontWeight: "bold", border: "1px solid black" }}>Biometric Image</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {tableData && tableData.map((item, idx) => (
                                    <TableRow key={idx} style={{ border: "1px solid black" }}>
                                        <TableCell style={{ border: "1px solid black", padding: "6px", width: 130, fontWeight: 'bold' }} align="left">{item.registrationNumber}</TableCell>
                                        <TableCell style={{ border: "1px solid black", padding: "6px", width: 130, fontWeight: 'bold' }} align="left">{item.employeeCode}</TableCell>
                                        <TableCell style={{ border: "1px solid black", padding: "6px", width: 110 }} align="left">{item.employeeName}</TableCell>
                                        <TableCell style={{ border: "1px solid black", padding: "6px", width: 110 }} align="left">{item.nicNumber}</TableCell>
                                        <TableCell style={{ border: "1px solid black", padding: "6px", width: 110 }} align="left ">{item.employeeTypeName}</TableCell>
                                        <TableCell style={{ border: "1px solid black", padding: "6px", width: 90 }} align="center">
                                            {item.convertEmployeeBiometricData !== null ? (
                                                <img
                                                    src={item.convertEmployeeBiometricData}
                                                    width="75"
                                                    height="100"
                                                    alt="Biometric Data"
                                                />
                                            ) : "N/A"}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
                <div>&nbsp;</div>
            </div>
        );
    }
}